import { CardBase } from '@facephi/ui-react';
import styled from 'styled-components';

export const SessionCard = styled(CardBase)`
  padding: 4rem;
  flex-grow: 1;
`;
